import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GROUPED_KPI_ICONS } from '@salescore/client-common'
import { Form, Select, Space } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

export const KpiFormIconFormItem = ({
  icon,
  onChangeIcon,
}: {
  icon: string | undefined
  onChangeIcon: (icon: string) => void
}): ReactElement => (
  <Form.Item label={t(`KPIアイコン`)}>
    <Select<string> value={icon} onChange={onChangeIcon}>
      {GROUPED_KPI_ICONS.map(([groupName, icons]) => (
        <Select.OptGroup key={groupName} label={groupName}>
          {icons.map((icon) => (
            <Select.Option key={`${icon.name}${icon.label ?? ''}`} value={icon.name}>
              <Space>
                <FontAwesomeIcon icon={icon.icon} />
                <span>{icon.label ?? icon.name}</span>
              </Space>
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}
    </Select>
  </Form.Item>
)
